import { Link } from "react-router-dom";
import { guidesForCategory } from "@/data/guidesByCategory";

interface GuideLinksProps {
  /** Category slug — an unknown or missing slug renders nothing. */
  categorySlug?: string;
  /** Lower-cased category name used in the intro line. */
  categoryName?: string;
}

/**
 * "Before you buy" — plain editorial links from shop pages into the journal.
 * Renders nothing when there are no guides for the category.
 */
export const GuideLinks = ({ categorySlug, categoryName }: GuideLinksProps) => {
  const guides = guidesForCategory(categorySlug);
  if (!guides.length) return null;

  return (
    <section className="border-t border-border">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-10 md:py-14">
        <p className="text-[11px] tracking-[0.2em] uppercase text-muted-foreground mb-3 font-medium">
          Before you buy
        </p>
        {categoryName && (
          <p className="text-[15px] text-muted-foreground leading-[1.7] mb-5 max-w-[60ch]">
            LoftLoom guides on choosing {categoryName.toLowerCase()}.
          </p>
        )}
        <ul className="space-y-2.5">
          {guides.map((g) => (
            <li key={g.slug}>
              <Link
                to={`/ideas/${g.slug}`}
                className="text-[16px] md:text-[17px] text-foreground underline decoration-border hover:decoration-foreground underline-offset-4 transition-colors"
              >
                {g.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
